module.exports = __webpack_public_path__ + "static/media/tensor-icon.ea9ea763.svg";